import Breadcrumb from "./Breadcrumb";

function PageHeader({ eyebrow, title, lead, crumb }) {
  return (
    <section className="page-header">
      <div className="container page-header__inner">
        <Breadcrumb current={crumb || title} />
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="page-header__title">
          <span className="gradient-text">{title}</span>
        </h1>
        {lead && <p className="page-header__lead">{lead}</p>}
      </div>
    </section>
  );
}

export default PageHeader;